var _excluded = ["className", "children"],
  _excluded2 = ["className"],
  _excluded3 = ["className", "children"],
  _excluded4 = ["isActive", "label", "icon", "alignIcon"],
  _excluded5 = ["className", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef, StylesProvider, useMultiStyleConfig, useStyles, useStyleConfig } from '../../system';
import { cx, isFunction } from '../../utils';
import { Flex } from '../layout';
import { IconButton } from '../button';
import { Checkbox } from '../checkbox';
import * as React from 'react';
export var ActionBarButton = forwardRef((_ref, ref) => {
  var {
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles();
  var buttonStyles = isFunction(styles['button']) ? styles['button'](rest) : styles['button'];
  return /*#__PURE__*/React.createElement(tqc.button, _extends({
    __css: buttonStyles,
    className: cx('tqc-action-bar-button', className),
    size: "xs",
    ref: ref
  }, rest), children);
});
export var ActionBarCheckbox = forwardRef((_ref2, ref) => {
  var {
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(Checkbox, _extends({
    className: cx('tqc-actionbar-checkbox', className),
    sx: styles.checkbox
  }, rest, {
    ref: ref
  }));
});
export var ActionBarIconButtonGroup = forwardRef((_ref3, ref) => {
  var {
      className,
      children
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Flex, _extends({
    ml: "auto",
    ref: ref,
    alignItems: "center",
    className: cx('tqc-actionbar-iconbutton-group', className)
  }, rest), children);
});
export var ActionBarIconButton = _ref4 => {
  var _rest$ariaLabel;
  var {
      isActive,
      label,
      icon,
      alignIcon = 'inline'
    } = _ref4,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  var styles = useStyles();
  var iconButtonStyles = useStyleConfig('IconButton', _objectSpread({}, rest));
  var buttonStyles = isFunction(styles['iconButton']) ? styles['iconButton']({
    isActive,
    label,
    alignIcon
  }) : styles['iconButton'];
  var iconElement = label ? /*#__PURE__*/React.createElement(React.Fragment, null, label, " ", icon) : icon;
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    __css: _objectSpread(_objectSpread({}, iconButtonStyles), buttonStyles)
  }, rest, {
    icon: iconElement,
    "aria-label": (_rest$ariaLabel = rest['aria-label']) !== null && _rest$ariaLabel !== void 0 ? _rest$ariaLabel : ''
  }));
};
export var ActionBar = _ref5 => {
  var {
      className,
      children
    } = _ref5,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  var styles = useMultiStyleConfig('ActionBar', rest);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(Flex, _extends({
    __css: styles.container,
    className: cx('tqc-actionbar', className)
  }, rest), children));
};
ActionBar.IconButtonGroup = ActionBarIconButtonGroup;
ActionBar.Button = ActionBarButton;
ActionBar.Checkbox = ActionBarCheckbox;
ActionBar.IconButton = ActionBarIconButton;